import React, { ReactNode } from "react"
import s from "./Navigation.less"

interface iNavigationItemProps {
  children: ReactNode
  className?: string
}

const NavigationItem: React.FC<iNavigationItemProps> = ({
  children,
  className,
}) => {
  return (
    <li className={`${s.item}${className ? ` ${className}` : ""}`}>
      {children}
    </li>
  )
}

export default NavigationItem
